import { Link } from 'react-router-dom';
import css from './partners.module.scss';
import { PARTNERSHIP } from 'src/constants/routes';
import { ReactComponent as LinkArrow } from 'src/assets/services-arrow-btn-2.svg';
import { Partner } from 'src/pages/partnership/types';

export default function Partners({ items, title }: Readonly<{ items: Partner[]; title?: string }>) {
  return (
    <div className={css.partners}>
      <header>
        <h2 id='partners'>{title ?? 'Партнери та надавачі послуг'}</h2>
        <Link to={PARTNERSHIP.path}>
          <p>Усі партнери</p>
          <LinkArrow className={css.arrow} />
        </Link>
      </header>
      <PartnersList items={items} />
      <div className={css.footer}>
        <Link to={PARTNERSHIP.path}>
          <p>Усі партнери</p>
        </Link>
      </div>
    </div>
  );
}

export function PartnersList({ items }: Readonly<{ items: Partner[] }>) {
  return (
    <div className={css.container}>
      <div className={css.logos}>
        <div className={css.logosContainer}>
          {items?.map((p: Partner) => (
            <a href={p.url} key={p.id} target='_blank' rel='noopener, noreferrer' title={p.name}>
              <img src={p.imgUrl} alt={p.name} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
